import { getUser as getState } from "modules/root/root-selectors";
import { createSelector } from "reselect";

export const getUser = getState;

export const getUserId = createSelector(getState, user => user.user_id);

export const getRefreshToken = createSelector(
  getState,
  state => state.refreshToken
);

export const getLanguage = createSelector(getState, state => state.language);

export const getConsent = createSelector(getState, state => state.consent);

export const getUserFormData = createSelector(
  getState,
  user => user.user_id && user
);

export const getUserSex = createSelector(getState, user => {
  if (!user.medical_properties || !user.medical_properties.sex) {
    return null;
  }
  if (user.medical_properties.sex === "1") {
    return "male";
  }
  return "female";
});



// WEBPACK FOOTER //
// ./src/modules/user/user-selectors.js